//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import "@/mixins/global";
import chartOTP from "../../components/chartOTPDocument";
import axios, { CancelToken } from "axios";

export default {
  components: {
    chartOTP
  },
  data() {
    return {
      ps: "202001",
      pe: "202053",
      chartDoc: [],
      teamNYV11D: [],
      teamNYV12D: [],
      teamNYV13D: [],
      teamTVN21D: [],
      teamTLA22D: [],

      chartSample: [],
      teamNYV11S: [],
      teamNYV12S: [],
      teamNYV13S: [],
      teamTVN21S: [],
      teamTLA22S: [],

      api: `${this.$apiFix}`
    };
  },
  async mounted() {
    let a = await this.defaultPeriod();
    this.loadData();
  },
  methods: {
    defaultPeriod() {
      let params = new FormData();
      const obj = axios({
        method: "post",
        url: this.$api + "otpmaster.php/otperiod",
        data: params
      }).then(res => {
        
        this.ps = res.data.ps;
        this.pe = res.data.pe;
      });

      return obj;
    },
    loadData() {
      axios
        .get(
          `${this.api}otp_vn.php/doc_nonpuma?ps=${this.ps}&pe=${this.pe}&team=`
        )
        .then(response => {
           console.log(response.data);
          this.chartDoc = response.data;
        });
      axios
        .get(
          `${this.api}otp_vn.php/doc_nonpuma?ps=${this.ps}&pe=${this.pe}&team=NYV1-1`
        )
        .then(response => {
         
          this.teamNYV11D = response.data;
        });
      axios
        .get(
          `${this.api}otp_vn.php/doc_nonpuma?ps=${this.ps}&pe=${this.pe}&team=NYV1-2`
        )
        .then(response => {
          this.teamNYV12D = response.data;
        });
      axios
        .get(
          `${this.api}otp_vn.php/doc_nonpuma?ps=${this.ps}&pe=${this.pe}&team=NYV1-3`
        )
        .then(response => {
          this.teamNYV13D = response.data;
        });
      axios
        .get(
          `${this.api}otp_vn.php/doc_nonpuma?ps=${this.ps}&pe=${this.pe}&team=TVN2-1`
        )
        .then(response => {
          this.teamTVN21D = response.data;
        });
      axios
        .get(
          `${this.api}otp_vn.php/doc_nonpuma?ps=${this.ps}&pe=${this.pe}&team=TLA2-2`
        )
        .then(response => {
          this.teamTLA22D = response.data;
        });

      axios
        .get(
          `${this.api}otp_vn.php/sample_nonpuma?ps=${this.ps}&pe=${this.pe}&team=`
        )
        .then(response => {
          this.chartSample = response.data;
        });
      axios
        .get(
          `${this.api}otp_vn.php/sample_nonpuma?ps=${this.ps}&pe=${this.pe}&team=NYV1-1`
        )
        .then(response => {
          this.teamNYV11S = response.data;
        });
      axios
        .get(
          `${this.api}otp_vn.php/sample_nonpuma?ps=${this.ps}&pe=${this.pe}&team=NYV1-2`
        )
        .then(response => {
          this.teamNYV12S = response.data;
        });
      axios
        .get(
          `${this.api}otp_vn.php/sample_nonpuma?ps=${this.ps}&pe=${this.pe}&team=NYV1-3`
        )
        .then(response => {
          this.teamNYV13S = response.data;
        });
      axios
        .get(
          `${this.api}otp_vn.php/sample_nonpuma?ps=${this.ps}&pe=${this.pe}&team=TVN2-1`
        )
        .then(response => {
          this.teamTVN21S = response.data;
        });
      axios
        .get(
          `${this.api}otp_vn.php/sample_nonpuma?ps=${this.ps}&pe=${this.pe}&team=TLA2-2`
        )
        .then(response => {
          this.teamTLA22S = response.data;
        });
    },
    goPage(routerName) {
      this.$router.push({
        name: routerName
      });
    }
  }
};
